<app-progress-bar [isVisible]="(isLoading | async) ?? false"></app-progress-bar>
<app-header
	class="horizontal-shadow"
	[class.shadow-visible]="isContentScrolled"
	[class.content-scrolled]="isContentScrolled"
></app-header>
<app-action-bar></app-action-bar>
<app-navigation
	[class.visible]="isMenuVisible"
	(closeMenu)="isMenuVisible = false"
></app-navigation>
<div class="content"
	 overlay-scrollbars [defer]="true" [options]="osDark"
	 waIntersectionObserver waIntersectionRoot
>
	<!--
	 Technically, these can trigger multiple entries per callback,
	 but setting the root to its parent should avoid that
	-->
	<div class="scroll-detect" (waIntersectionObservee)="isContentScrolled = !$event[0].isIntersecting"></div>
	<router-outlet></router-outlet>

	<!--
	 No idea why, but including zendesk chat component at the root level of this template interferes with
	 the app-navigation	menu open/close when on compact screen widths (doesn't seem to be a z-index issue)
	 -->
	<app-zendesk-chat></app-zendesk-chat>
</div>
